<div style="background-color: white" id="modal-visualizar-historico">
	<div class="card card-secondary card-outline" cdkDragBoundary="html" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
	</div>

	<div class="card-header bg-light" cdkDragHandle>
		<h4 class="card-title mb-0">Capítulo/Subcapítulo</h4>
		<div class="card-tools">
			<button type="button" class="btn btn-tool" (click)="fechar()">
				<i class="fas fa-times"></i>
			</button>
		</div>
	</div>

	<div class="card-body">
		<div class="row">
			<div class="form-group col-md-3">
				<label for="dataAlteracao" class="mb-1">Data da Alteração</label>
				<input disabled type="text" id="dataAlteracao" class="form-control form-control-sm" maxlength="100"
					[value]="getFormattedDate(historico.dataAlteracao)" />
			</div>
			<div class="form-group col-md-9">
				<label for="realizadoPor" class="mb-1">Realizado Por</label>
				<input disabled type="text" id="realizadoPor" class="form-control form-control-sm" maxlength="100"
					[value]="
						historico?.usuario === undefined
							? ''
							: historico.usuario
					" />
			</div>
			<!-- <div class="row">
				<label for="dadosCapitulo">Dados do Capítulo Anterior</label>
				<p [innerHTML]="textoRemovido"></p>
			</div>
			<div class="row">
				<label for="alteracao">Alteração</label>
				<p [innerHTML]="textoDestacado"></p>
			</div> -->
		</div>
		<div class="row">
			<div class="form-group col-md-12">
				<h5><label class="row">Dados Anteriores</label></h5>
			</div>

			<div class="capituloAnterior form-group col-md-12">
				<label>Nome</label>
				<span class="diff-container" [innerHTML]="historico.nomeAnterior"></span>
			</div>

			<div class="capituloAnterior form-group col-md-12">
				<label>Conteúdo</label>
				<span class="diff-container" [innerHTML]="historico.conteudoAnterior"></span>
			</div>

			<div class="form-group col-md-12" [hidden]="removidoNome.trim() == '' && removidoConteudo.trim() == '' ">
				<h5><label class="diff-container" [hidden]="removido == ''" for="alteracao">Informações removidas:</label></h5>
			</div>
			<div [hidden]="removidoNome.trim() == ''" class="capituloAtual form-group col-md-12">
				<label class="mb-1">Nome</label>
				<span [class.destaqueSublinhado]="removidoNome != ''" class="diff-container"
					[innerHTML]="removidoNome"></span>
			</div>
			<div [hidden]="removidoConteudo.trim() == ''"  class="capituloAtual form-group col-md-12">
				<label class="mb-1">Conteúdo</label>
				<span [class.destaqueSublinhado]="removidoConteudo != ''" class="diff-container"
					[innerHTML]="removidoConteudo"></span>
			</div>
			<div class="capituloAtual form-group col-md-12 row" [hidden]="removidoNome.trim() == '' && removidoConteudo.trim() == '' ">
				<div class="col">
					<label [hidden]="removido == ''">Data Alteração: </label>
				</div>
				<div class="col">
					<label [hidden]="removido == ''" class="row" [innerHTML]="dataFormatada"></label>
				</div>
			</div>
		</div>
		<div class="row">
			<h5><label for="alteracao">Alteração</label></h5>
			<div class="capituloAtual form-group col-md-12">
				<label class="mb-1">Nome</label>
				<span class="diff-container" id="alteracao" [innerHTML]="historico.nomeAtual">
				</span>
			</div>
			<div class="capituloAtual form-group col-md-12">
				<label class="mb-1">Conteúdo</label>
				<span class="diff-container" id="alteracao" [innerHTML]="historico.conteudoAtual">
				</span>
			</div>
			<div class="capituloAtual form-group col-md-12">
				<h5><label class="row" [hidden]="adicionadoNome == '' && adicionadoConteudo == ''" for="alteracao">Informações adicionadas:</label></h5>
			</div>
			<div [hidden]="adicionadoNome == ''" class="capituloAtual form-group col-md-12">
				<label class="mb-1">Nome</label>
				<span [class.destaqueTexto]="adicionadoNome != ''" class="diff-container"
					[innerHTML]="adicionadoNome">
				</span>
			</div>
			<div [hidden]="adicionadoConteudo == ''" class="capituloAtual form-group col-md-12">
				<label class="mb-1">Conteúdo</label>
				<span [class.destaqueTexto]="adicionadoConteudo != ''" class="diff-container"
					[innerHTML]="adicionadoConteudo">
				</span>
			</div>
			<div [hidden]="adicionado == ''" class="capituloAtual form-group col-md-12 row">
				<div class="col">
					<label>Data Alteração: </label>
				</div>
				<div class="col">
					<label [hidden]="adicionado == ''" class="row" [innerHTML]="dataFormatada"></label>
				</div>
			</div>
		</div>
	</div>
	<div class="card-footer">
		<button type="button" class="btn btn-default btn-sm" (click)="fechar()">
			<i class="fas fa-times"></i> Fechar
		</button>
	</div>
</div>